import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Container, Row, Col, Card, Badge } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronLeft, faCalendarDay, faMapMarkerAlt, faTags, faImages, faAlignLeft
} from "@fortawesome/free-solid-svg-icons";
import useFetch from "../../../../hooks/useFetch";

const API_URL = process.env.REACT_APP_API_URL;

export default function EventoDetalhe() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { get } = useFetch();

    const [state, setState] = useState({ evento: null, fotos: [], loading: true });

    useEffect(() => {
        window.scrollTo(0, 0);
        async function carregar() {
            try {
                let response = await get(`/acervo/eventos/${id}`);
                if (response.ok && response.result.data) {
                    setState({ evento: response.result.data.evento, fotos: response.result.data.fotos ?? [], loading: false });
                } else {
                    setState({ evento: null, fotos: [], loading: false });
                }
            } catch (error) {
                console.error("Erro no carregar():", error);
                setState({ evento: null, fotos: [], loading: false });
            }
        }
        carregar();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    if (state.loading) {
        return <Container className="py-5" style={{marginTop: '100px'}}><div className="text-center"><div className="spinner-border text-teal"></div></div></Container>;
    }

    if (!state.evento) return <Container className="py-5" style={{marginTop: '100px'}}><h3>Evento não encontrado</h3></Container>;

    const evento = state.evento;

    const formatarPeriodo = (inicio, fim) => {
        if (!inicio) return "---";
        const f = (d) => d.split('-').reverse().join('/');
        if (!fim || inicio === fim) return f(inicio);
        return `De ${f(inicio)} até ${f(fim)}`;
    };

    return (
        <div className="detail-page-wrapper pb-5">
            <Container>
                <div className="mb-4">
                    <button onClick={() => navigate(-1)} className="btn-back-modern">
                        <FontAwesomeIcon icon={faChevronLeft} className="me-2" />
                        Voltar
                    </button>
                </div>

                <div className="section-title-modern mb-5">
                    <div className="title-accent"></div>
                    <h2 className="title-text">{evento.nome_evento}</h2>
                </div>

                <Row className="g-5">
                    <Col lg={4}>
                        <Card className="border-0 shadow-sm rounded-4 overflow-hidden mb-4">
                            <div className="bg-teal p-4 text-white text-center">
                                <FontAwesomeIcon icon={faCalendarDay} size="3x" className="mb-3 opacity-50" />
                                <h5 className="mb-0">Informações do Evento</h5>
                            </div>
                            <Card.Body className="p-4">
                                <div className="info-item mb-4">
                                    <small className="text-muted d-block fw-bold small text-uppercase">
                                        <FontAwesomeIcon icon={faTags} className="me-1" /> Tipo de Evento
                                    </small>
                                    <span className="fw-bold text-dark">{evento.tipo_evento || "---"}</span>
                                </div>

                                <div className="info-item mb-4">
                                    <small className="text-muted d-block fw-bold small text-uppercase">
                                        <FontAwesomeIcon icon={faCalendarDay} className="me-1" /> Data / Período
                                    </small>
                                    <span className="fw-bold text-dark">
                                        {formatarPeriodo(evento.data_inicio, evento.data_fim)}
                                    </span>
                                </div>

                                <div className="info-item">
                                    <small className="text-muted d-block fw-bold small text-uppercase">
                                        <FontAwesomeIcon icon={faMapMarkerAlt} className="me-1" /> Localização
                                    </small>
                                    <span className="fw-bold text-dark">{evento.local_evento || "---"}</span>
                                </div>
                            </Card.Body>
                        </Card>

                        <div className="p-4 bg-white rounded-4 shadow-sm border-start border-teal border-4">
                            <h6 className="fw-bold text-teal mb-2">
                                <FontAwesomeIcon icon={faImages} className="me-2" />
                                Registros do Evento
                            </h6>
                            <p className="small text-muted mb-0">
                                Existem <strong>{state.fotos.length} fotos</strong> vinculadas a este momento histórico.
                            </p>
                        </div>
                    </Col>

                    <Col lg={8}>
                        <div className="narrative-card p-4 rounded-4 shadow-sm bg-white mb-5">
                            <h4 className="narrative-title border-bottom pb-3 mb-4">
                                <FontAwesomeIcon icon={faAlignLeft} className="me-2 text-teal" />
                                Descrição do Evento
                            </h4>
                            <p className="narrative-text" style={{textAlign: 'justify', lineHeight: '1.8'}}>
                                {evento.descricao || "Nenhuma descrição detalhada disponível para este evento."}
                            </p>
                        </div>

                        <div className="related-works-section">
                            <div className="d-flex align-items-center mb-4">
                                <h4 className="text-dark fw-bold mb-0">Galeria do Evento</h4>
                                <div className="ms-3 flex-grow-1 border-bottom"></div>
                            </div>

                            <Row className="g-4">
                                {state.fotos.map(foto => (
                                    <Col md={6} key={foto.id_fotografia}>
                                        <Link to={`/acervo/iconografia/${foto.id_fotografia}`} className="text-decoration-none">
                                            <Card className="photo-result-card border-0 shadow-sm h-100">
                                                <div className="photo-container">
                                                    <Badge className="tombo-badge">{foto.numero_tombo}</Badge>
                                                    <img src={`${API_URL}/acervo/fotografias/${foto.id_fotografia}/imagem`} alt={foto.titulo_atribuido} onError={(e) => { e.target.style.display = 'none'; }} />
                                                </div>
                                                <Card.Body className="p-3">
                                                    <h6 className="photo-title-main mb-1 text-truncate">{foto.titulo_atribuido}</h6>
                                                    <div className="d-flex justify-content-between align-items-center mt-2">
                                                        <small className="text-muted">{foto.ano_producao ?? "-"}</small>
                                                        <span className="small text-teal fw-bold">Ver foto →</span>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </Col>
                                ))}
                            </Row>

                            {state.fotos.length === 0 && (
                                <div className="text-center py-5 bg-white rounded-4 shadow-sm">
                                    <p className="text-muted mb-0">Nenhuma fotografia vinculada a este evento no momento.</p>
                                </div>
                            )}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}
